import React, { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FieldIssue } from '~/utils/detectFieldIssue';

interface Props {
  issue: FieldIssue;
}

/**
 * Displays a red 'Missing Value' or 'Arabic Value' label
 * below a ReviewItem when a Thiqah-sourced field has an issue.
 * Renders nothing when issue is null.
 */
const AgentMissingValueLabel: FC<Props> = ({ issue }) => {
  const { t } = useTranslation('ksaReview');
  if (!issue) return null;
  return (
    <StyledLabel>
      {issue === 'missing' ? t('Missing Value') : t('Arabic Value')}
    </StyledLabel>
  );
};

const StyledLabel = styled(Typography.Text)`
  display: block;
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
`;

export default AgentMissingValueLabel;
